export default __webpack_public_path__ + "7d8101dbf59d19447f2559039897e976.png";